import { render, staticRenderFns } from "./customerWidget.vue?vue&type=template&id=11e169d5"
import script from "./customerWidget.vue?vue&type=script&lang=js"
export * from "./customerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports